import { UserService } from "_services";
import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import { SelectPicker, DateRangePicker, Stack, Accordion } from "rsuite";

import { Loader } from "rsuite";
import FilterSearch from "./FilterSearch";

import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import startOfMonth from "date-fns/startOfMonth";
import endOfMonth from "date-fns/endOfMonth";
import addMonths from "date-fns/addMonths";
import { getCurrency } from "components/Navbar/NavUserBox";
import { BiTransferAlt } from "react-icons/bi";

const Coupons = (props) => {
  const [loading, setLoading] = useState(false);
  const [coupons, setCoupons] = useState([]);

  const [page, setPage] = React.useState(1);
  const [canLoadMore, setCanLoadMore] = useState(true);

  const [FilterSearchValue, setFilterSearchValue] = useState("");
  const [DateValue, setDateValue] = useState([
    new Date(moment().startOf("day").add(1, "seconds")),
    new Date(moment().endOf("day").subtract(1, "seconds")),
  ]);
  const [TypeValue, setTypeValue] = useState(null);
  const [Begin, setBegin] = useState(
    new Date(moment().startOf("day").add(1, "seconds"))
  );
  const [End, setEnd] = useState(
    new Date(moment().endOf("day").subtract(1, "seconds"))
  );

  const [updatedTime, setUpdatedTime] = useState(new Date().toJSON());
  const containerRef = useRef(null);

  const [visibleData, setVisibleData] = useState([]);
  const [lastScrollTop, setLastScrollTop] = useState(0);

  useEffect(() => {
    GetCoupons();
  }, []);
  useEffect(() => {
    GetCoupons();
  }, [props.user]);

  const GetCoupons = async (page = 1, search, type, begin, end) => {
    if (!loading) {
      setLoading(true);
      await UserService.READ_TICKETS(page, search, type, begin, end)
        .then((res) => {
          adjustHeight();

          setLoading(false);
          setCoupons(res);
          setUpdatedTime(new Date().toJSON());
          const data = [...coupons];
          const _v = data.slice(0, 36);
          setVisibleData(_v);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };

  const GetCouponsMore = async () => {
    if (canLoadMore) {
      await UserService.READ_TICKETS(page + 1)
        .then((res) => {
          setLoading(false);
          if (res.length > 0) {
            setPage(page + 1);
            setCoupons([...coupons, ...res]);
          } else {
            setCanLoadMore(false);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };

  const adjustHeight = () => {
    try {
      const navbarHeight = document.querySelector(".base-nav")?.offsetHeight;
      const navbarHeight1 = document.querySelector(".base-nav1")?.offsetHeight;
      const windowHeight = window.innerHeight;
      const myaccountMenu =
        document.querySelector(".myaccountMenu")?.offsetHeight;
      if (containerRef && containerRef.current) {
        const h =
          windowHeight -
          (navbarHeight > navbarHeight1 ? navbarHeight : navbarHeight1) -
          myaccountMenu;

        containerRef.current.style.height = `${h}px`;
      }
    } catch (error) {
      // Error handling
    }
  };

  const handleScroll = () => {
    const data = [...coupons];
    const { scrollTop, clientHeight, scrollHeight } = containerRef.current;
    if (scrollTop + clientHeight >= scrollHeight) {
      setVisibleData((prevData) => [
        ...prevData,
        ...data.slice(prevData.length, prevData.length + 20),
      ]);
      setUpdatedTime(new Date().toJSON());

      if (!loading && data.length > 0 && data.length == visibleData.length) {
        GetCouponsMore();
      }
    }

    setLastScrollTop(scrollTop <= 0 ? 0 : scrollTop);
  };
  useEffect(() => {
    const data = [...coupons];
    const _v = data.slice(0, 36);
    setVisibleData(_v);
  }, []);

  return (
    <Translation>
      {(t) => (
        <div className="h-full p-2">
          <div>
            <h1 className="text-lg px-2 py-2">{t("TITLE_MYBETS")}</h1>
          </div>
          <div
            ref={containerRef}
            onScroll={handleScroll}
            style={{ overflowY: "scroll", paddingBottom: "180px" }}
          >
            <div className="pb-2">
              <Stack spacing={6} className="p-1">
                <Stack.Item grow={1}>
                  <DateRangePicker
                    className={"block"}
                    value={DateValue}
                    ranges={predefinedRanges}
                    showOneCalendar
                    placeholder={t("TITLE_BEGIN_END_DATES")}
                    //  defaultValue={[new Date(),new Date()]}
                    onShortcutClick={(shortcut, event) => {
                      // console.log(shortcut);
                    }}
                    onChange={(value) => {
                      if (value && value.length > 1) {
                        const begin = value[0];
                        const end = value[1];
                        setDateValue(value);
                        // setTypeValue(null);
                        setBegin(begin);
                        setEnd(end);
                        setFilterSearchValue("");

                        GetCoupons(
                          1,
                          null,
                          TypeValue == "all" ? null : TypeValue,
                          begin.toJSON(),
                          end.toJSON()
                        );
                        //getListData(begin.toJSON(), end.toJSON());
                      } else {
                        setBegin(null);
                        setEnd(null);
                        setDateValue(null);
                      }
                    }}
                  />
                </Stack.Item>
                <Stack.Item grow={1}>
                  <SelectPicker
                    className="block"
                    size="md"
                    value={TypeValue}
                    placeholder={t("TITLE_TICKET_STATUS")}
                    data={[
                      {
                        label: t("TICKET_STATUS_ALL"),
                        value: "all",
                      },
                      {
                        label: t("TICKET_STATUS_W"),
                        value: "Won",
                      },
                      {
                        label: t("TICKET_STATUS_L"),
                        value: "Lost",
                      },
                      {
                        label: t("TICKET_STATUS_N"),
                        value: "Pending",
                      },
                    ]}
                    onChange={(value) => {
                      setTypeValue(value);
                      GetCoupons(
                        1,
                        null,
                        value == "all" ? null : value,
                        new Date(Begin).toJSON(),
                        new Date(End).toJSON()
                      );
                      // setFilterSearchValue(null);
                      // setDateValue(null);
                    }}
                  />
                </Stack.Item>
              </Stack>
              <FilterSearch
                FilterSearchValue={FilterSearchValue}
                setFilterSearchValue={(value) => {
                  setFilterSearchValue(value);
                  if (value.trim().length > 1) {
                    GetCoupons(
                      1,
                      value,
                      TypeValue == "all" ? null : TypeValue,
                      Begin,
                      End
                    );
                    //setDateValue(null);
                    //setTypeValue(null);
                  }
                }}
                placeholder={t("PLACEHOLDER_TICKET")}
              />
            </div>
            {!([...coupons].length > 0) && (
              <div className="flex flex-col justify-center items-center p-2">
                <span className="italic text-secondary-400">
                  {t("PLACEHOLDER_NO_DATA_TICKET")}
                </span>
              </div>
            )}

            {coupons.length > 0 && (
              <Accordion className="accordionMain">
                {coupons.map((item, key) => {
                  return (
                    <Accordion.Panel
                      key={key + "acc"}
                      className="border accordionPanel relative border-[#262a30]  bg-secondary-500 rounded-md mb-2"
                      classPrefix={
                        "   border-1 border-secondary-300/20  rounded-md "
                      }
                      header={
                        <div
                          key={key}
                          className={
                            "w-full p-4 mr-6 relative " +
                            " text-[2.3133333333vw] md:text-sm font-medium "
                          }
                        >
                          {/* Header Row - Left: Bet Type Icon + Text + ID, Right: Status + Date */}
                          <div className="flex justify-between items-start mb-4">
                            {/* Left Side: Bet Type Icon, Text, and Ticket ID */}
                            <div className="flex items-center gap-2">
                              {/* Bet Type Icon - Circle with number for Single, Y-shape for Multiple */}
                              {(() => {
                                const betTypeNum = parseInt(item.BetType) || 1;
                                // 1 = Single/Ordinar
                                if (betTypeNum === 1 || item.BetType === "Single" || item.BetType === "Ordinar") {
                                  return (
                                    <div className="w-6 h-6 rounded-full bg-white flex items-center justify-center">
                                      <span className="text-secondary-500 font-bold text-xs">1</span>
                                    </div>
                                  );
                                }
                                // 2+ = Multiple/Express/System/Chain/etc.
                                return (
                                  <div className="w-6 h-6 flex items-center justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 text-white">
                                      <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z" />
                                      <path d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z" />
                                    </svg>
                                  </div>
                                );
                              })()}
                              <span className="text-white font-medium text-sm">
                                {(() => {
                                  const betTypeNum = parseInt(item.BetType) || 1;
                                  const betTypeMap = {
                                    1: t("COUPON_BET_TYPE_SINGLE"),
                                    2: t("COUPON_BET_TYPE_MULTIPLE"),
                                    3: t("COUPON_BET_TYPE_SYSTEM"),
                                    4: t("COUPON_BET_TYPE_CHAIN"),
                                    5: t("COUPON_BET_TYPE_TRIXIE"),
                                    6: t("COUPON_BET_TYPE_YANKEE"),
                                    7: t("COUPON_BET_TYPE_PERMED_YANKEE"),
                                    8: t("COUPON_BET_TYPE_SUPER_YANKEE"),
                                    9: t("COUPON_BET_TYPE_HEINZ"),
                                    10: t("COUPON_BET_TYPE_SUPER_HEINZ"),
                                    11: t("COUPON_BET_TYPE_GOLIATH"),
                                    12: t("COUPON_BET_TYPE_PATENT"),
                                    13: t("COUPON_BET_TYPE_PERMED_PATENT"),
                                    14: t("COUPON_BET_TYPE_LUCKY15"),
                                    15: t("COUPON_BET_TYPE_LUCKY31"),
                                    16: t("COUPON_BET_TYPE_LUCKY63")
                                  };
                                  return betTypeMap[betTypeNum] ||
                                    (item.BetType === "Single" ? t("COUPON_BET_TYPE_SINGLE") :
                                      item.BetType === "Ordinar" ? t("COUPON_BET_TYPE_SINGLE") :
                                        item.BetType === "Multiple" ? t("COUPON_BET_TYPE_MULTIPLE") :
                                          item.BetType === "Express" ? t("COUPON_BET_TYPE_MULTIPLE") :
                                            t("COUPON_BET_TYPE_MULTIPLE"));
                                })()}
                              </span>
                              <span className="text-white font-medium text-sm">
                                {item.TicketID}
                              </span>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigator.clipboard.writeText(item.TicketID);
                                }}
                                className="text-white/50 hover:text-white"
                                title="Copy Ticket ID"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184" />
                                </svg>
                              </button>
                            </div>

                            {/* Right Side: Status Badge and Date */}
                            <div className="flex flex-col items-end">
                              <span
                                className={
                                  " uppercase font-bold text-sm mb-1 " +
                                  (item.TicketStatus === "CashedOut"
                                    ? "text-[#20bdf0]"
                                    : item.TicketStatus === "Won"
                                      ? "text-green-400"
                                      : item.TicketStatus === "Lost"
                                        ? "text-red-400"
                                        : "text-white/50"
                                  )
                                }
                              >
                                {item.TicketStatus === "CashedOut"
                                  ? "CASHED OUT"
                                  : item.TicketStatus === "Won"
                                    ? "WON"
                                    : (item.TicketStatus === "Lost" ? "LOST" : item.TicketStatus)}
                              </span>
                              <p className={`text-white/50 text-xs m-0`}>
                                {moment(new Date(item.CreateTime)).format("DD.MM.YYYY, HH:mm")}
                              </p>
                            </div>
                          </div>

                          {/* Bet Information: Stake, Odds, Outcome */}
                          <div className="space-y-2 mb-4">
                            <div className="flex justify-between items-center">
                              <span className="text-white text-sm">{t("COUPON_STAKE")}...</span>
                              <span className="text-white font-bold text-sm">
                                {item.Bet.toLocaleString("tr-TR", {
                                  maximumFractionDigits: 2,
                                  minimumFractionDigits: 2,
                                }) + " " + getCurrency(item.Currency?.Currency)}
                              </span>
                            </div>
                            <div className="flex justify-between items-center">
                              <span className="text-white text-sm">{t("COUPON_ODDS_DECIMAL")}</span>
                              <span className={`text-yellow-400 font-bold text-sm`}>
                                {item.ticketodds.toLocaleString("tr-TR", {
                                  maximumFractionDigits: 2,
                                  minimumFractionDigits: 2,
                                })}
                              </span>
                            </div>
                            <div className="flex justify-between items-center">
                              <span className="text-white text-sm">{t("COUPON_OUTCOME")}</span>
                              <span className={`${item.TicketStatus === "Won" ?
                                "text-green-400 " : item.TicketStatus === "Lost" ?
                                  "text-red-400 " : item.TicketStatus === "CashedOut" ?
                                    "text-[#20bdf0] " : "text-yellow-400 "} font-bold text-sm`}>
                                {
                                    item.TicketStatus === "Won" ?
                                      (() => {
                                        const betResulted = item.BetPlacedData?.find((e) => e.eventType === "BetResulted");
                                        const hasVoid = betResulted?.requestData?.BetSelectionState?.some((s) => s.State === 2);
                                        const amount = hasVoid && betResulted?.requestData?.Amount != null
                                          ? betResulted.requestData.Amount
                                          : (item.MaxWin * item.Bet);
                                        return amount?.toLocaleString("tr-TR", {
                                          maximumFractionDigits: 2,
                                          minimumFractionDigits: 2,
                                        }) + " " + getCurrency(item.Currency?.Currency);
                                      })() :
                                      item.TicketStatus === "Pending" ?
                                        (item.MaxWin * item.Bet)?.toLocaleString("tr-TR", {
                                          maximumFractionDigits: 2,
                                          minimumFractionDigits: 2,
                                        }) + " " + getCurrency(item.Currency?.Currency) :
                                        item.TicketStatus === "Lost" ?
                                          (0).toLocaleString("tr-TR", {
                                            maximumFractionDigits: 2,
                                            minimumFractionDigits: 2,
                                          }) + " " + getCurrency(item.Currency?.Currency) :
                                          item.TicketStatus === "CashedOut" ?
                                            (item.hasOwnProperty("BetPlacedData") ? item?.BetPlacedData?.map(x => x.requestData.Amount)?.reduce((a, b) => a + b, 0) : 0)?.toLocaleString("tr-TR", {
                                              maximumFractionDigits: 2,
                                              minimumFractionDigits: 2,
                                            }) + " " + getCurrency(item.Currency?.Currency) :
                                            item?.Bet?.toLocaleString("tr-TR", {
                                              maximumFractionDigits: 2,
                                              minimumFractionDigits: 2,
                                            }) + " " + getCurrency(item.Currency?.Currency)}
                              </span>
                            </div>
                            {item.BetPlacedData.length > 1 && item.TicketStatus === "CashedOut" && (
                              item.BetPlacedData.map((x, index) => {
                                return (
                                  <div className="flex justify-between items-center">
                                    <span className="text-white text-sm">{t("COUPON_BET_PARTIAL_CASHOUT") + " " + (index + 1)}</span>
                                    <span className="text-white text-xs">{x.requestData.Amount?.toLocaleString("tr-TR", {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2,
                                    })} {" " + getCurrency(item.Currency?.Currency)}</span>
                                  </div>
                                )
                              })
                            )}
                            <div></div>
                          </div>

                          {/* BET DETAILS Button */}
                          <div className="flex items-center justify-between pt-3 border-t border-white/10 bg-secondary-500/50">
                            <span className="text-white font-medium text-sm">{t("COUPON_BET_DETAILS")}</span>
                            <div className="flex items-center gap-1">
                              <span className="text-white text-sm font-medium">
                                {item.TicketData?.length || 1}
                              </span>
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4 text-white">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      }
                    >
                      <div
                        style={{ visibility: "visible" }}
                        className="collapse-content text-white  p-2 rounded-md  "
                      >
                        <div className="flex flex-col space-y-3">
                          {item.TicketData.map((i, k) => {
                            // Format SelectionName to show team name if W1/W2/WX
                            let displaySelection = i.SelectionName || "";
                            if (i.SelectionName === "W1" && i.HomeTeamName) {
                              displaySelection = i.HomeTeamName;
                            } else if (i.SelectionName === "W2" && i.AwayTeamName) {
                              displaySelection = i.AwayTeamName;
                            } else if (i.SelectionName === "X" || i.SelectionName === "Draw") {
                              displaySelection = "Draw";
                            }

                            return (
                              <div
                                key={k + "ticketbody"}
                                className="border-t border-white/10  first:border-t-0 first:pt-0 bg-secondary-400/60 p-2 rounded-md"
                              >
                                {/* Pick Section */}
                                <div className="flex justify-between items-start mb-3">
                                  <div className="flex-1">
                                    <div className="text-yellow-500 font-bold text-sm mb-1">
                                      {t("COUPON_PICK")}: {displaySelection || "-"}
                                    </div>
                                    {i.MarketName && (
                                      <div className="text-white text-sm">
                                        {i.MarketName}
                                      </div>
                                    )}
                                  </div>
                                  <div className="text-yellow-500 font-bold text-lg ml-4">
                                    {i.Price ? i.Price : ""}
                                  </div>
                                </div>

                                {/* Match Information Section */}
                                <div className="flex justify-between items-start mb-3 border-t border-white/10 pt-3">
                                  <div className="flex-1">
                                    {i.HomeTeamName && (
                                      <div className="text-white text-sm mb-1">
                                        {i.HomeTeamName}
                                      </div>
                                    )}
                                    {i.AwayTeamName && (
                                      <div className="text-white text-sm mb-2">
                                        {i.AwayTeamName}
                                      </div>
                                    )}
                                    <div className="flex items-center gap-2">
                                      <span
                                        className={
                                          "dashboard-sport-icon " + i.SportName
                                        }
                                      ></span>
                                      <span className="text-white text-sm">
                                        {i.CompetitionName || i.SportName || "-"}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="text-white text-sm ml-4">
                                    {moment(new Date(i.MatchStartDate)).format("DD.MM.YYYY, HH:mm")}
                                  </div>
                                </div>

                                {/* Score Section */}

                                <div className="flex justify-between items-start mb-3">
                                  <div> {i.MatchInfo && (
                                    <div className="border-t border-white/10 pt-3">
                                      <div className="text-white text-sm mb-1">{t("COUPON_SCORE_LABEL")} :</div>
                                      <div className="text-white text-sm">
                                        {i.MatchInfo}
                                      </div>
                                    </div>
                                  )}</div>
                                  <div className="ml-4">
                                    {item.hasOwnProperty("BetEvents") && (() => {
                                      const betEvent = item.BetEvents.find(
                                        (x) => x.oddId === i.SelectionId
                                      );

                                      if (!betEvent || betEvent.status === undefined || betEvent.status === null) {
                                        return null;
                                      }

                                      const statusMap = {
                                        0: { label: "Not Resulted", color: "bg-gray-500/70", text: "text-gray-100" },
                                        1: { label: "Placed", color: "bg-blue-500/80", text: "text-white" },
                                        2: { label: "Returned", color: "bg-yellow-500/80", text: "text-black" },
                                        3: { label: "Lost", color: "bg-red-600/80", text: "text-white" },
                                        4: { label: "Won", color: "bg-green-600/80", text: "text-white" },
                                        5: { label: "Win Return", color: "bg-emerald-500/80", text: "text-white" },
                                        6: { label: "Loss Return", color: "bg-orange-500/80", text: "text-white" },
                                      };

                                      const statusCfg = statusMap[betEvent.status] || {
                                        label: betEvent.status,
                                        color: "bg-gray-600/80",
                                        text: "text-white",
                                      };

                                      return (
                                        <div
                                          className={[
                                            "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold border border-white/10 uppercase ",
                                            statusCfg.color,
                                            statusCfg.text,
                                          ].join(" ")}
                                        >
                                          {statusCfg.label}
                                        </div>
                                      );
                                    })()}
                                  </div>

                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </Accordion.Panel>
                  );
                })}
              </Accordion>
            )}
          </div>

          {loading && <Loader backdrop center />}
        </div>
      )}
    </Translation>
  );
};

const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn } = authentication;
  const { sports, games } = game;
  return {
    user,
    loggedIn,
    sports,
    games,
  };
};
const mapDispatchToProps = {};

/*
.filter((x) =>
                  x.TicketID.toLocaleLowerCase().includes(
                    FilterSearchValue?.toLocaleLowerCase()
                  )
                )
*/

export default connect(mapStateToProps, mapDispatchToProps)(Coupons);

export const predefinedRanges = [
  {
    label: "Today",
    value: [new Date(), new Date()],
    placement: "left",
  },
  {
    label: "Yesterday",
    value: [addDays(new Date(), -1), addDays(new Date(), -1)],
    placement: "left",
  },
  {
    label: "This week",
    value: [startOfWeek(new Date()), endOfWeek(new Date())],
    placement: "left",
  },
  {
    label: "Last 7 days",
    value: [subDays(new Date(), 6), new Date()],
    placement: "left",
  },
  {
    label: "Last 30 days",
    value: [subDays(new Date(), 29), new Date()],
    placement: "left",
  },
  {
    label: "This month",
    value: [startOfMonth(new Date()), new Date()],
    placement: "left",
  },
  {
    label: "Last month",
    value: [
      startOfMonth(addMonths(new Date(), -1)),
      endOfMonth(addMonths(new Date(), -1)),
    ],
    placement: "left",
  },
  {
    label: "This year",
    value: [new Date(new Date().getFullYear(), 0, 1), new Date()],
    placement: "left",
  },
  {
    label: "Last year",
    value: [
      new Date(new Date().getFullYear() - 1, 0, 1),
      new Date(new Date().getFullYear(), 0, 0),
    ],
    placement: "left",
  },
  {
    label: "All time",
    value: [new Date(new Date("01/01/2020").getFullYear(), 0, 1), new Date()],
    placement: "left",
  },
  {
    label: "Last week",
    closeOverlay: false,
    value: (value) => {
      const [start = new Date()] = value || [];
      return [
        addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
        addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
      ];
    },
    appearance: "default",
  },
  {
    label: "Next week",
    closeOverlay: false,
    value: (value) => {
      const [start = new Date()] = value || [];
      return [
        addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
        addDays(endOfWeek(start, { weekStartsOn: 0 }), 7),
      ];
    },
    appearance: "default",
  },
];
